import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import RealTimeTrackingForm from "./RealTimeTrackingComponents/RealTimeTrackingForm";

import {
  useGetRealTimeTrackingDetailQuery,
  useUpdateRealTimeTrackingMutation,
} from "store/services/realTimeTrackingApi";

import { useAppMeta } from "hooks";

const RealTimeTrackingEditScreen = () => {
  const { id } = useParams(); // Get realtime tracking ID from the URL parameters
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Real-Time Tracking", path: "/app/realtime-tracking/realtime/list" },
    { title: "Edit Tracking" },
  ];

  // RTK Query to fetch tracking details
  const {
    data: trackingDetail,
    isLoading: loadingTrackingDetail,
    error,
  } = useGetRealTimeTrackingDetailQuery(id);

  // RTK Mutation to update tracking details
  const [updateRealTimeTracking, { isLoading: updatingTracking }] =
    useUpdateRealTimeTrackingMutation();

  // Update handler
  const handleUpdateTracking = async (data) => {
    const payload = { id, ...data };

    try {
      await updateRealTimeTracking(payload).unwrap();
      toast.success("Real-time tracking successfully updated!");
      navigate(`/app/crm/realtime-tracking/${id}/detail`); // Redirect to tracking detail page
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update realtime tracking!"
      );
    }
  };

  useAppMeta("Edit realtime Tracking");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingTrackingDetail || updatingTracking}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <RealTimeTrackingForm
          isBusy={loadingTrackingDetail || updatingTracking}
          trackingDetail={trackingDetail} // Pass the fetched tracking details to the form
          onSubmit={handleUpdateTracking}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default RealTimeTrackingEditScreen;
